import { useEffect, useState } from 'react';
import {
  getSalesTargetSetOverlayContext,
  subscribeSalesTargetSetOverlay,
  type SalesTargetSetOverlayContext,
} from '@shared/lib/frontend/utils/salesTargetSetBridge';

export function useSalesTargetSetOverlay(): SalesTargetSetOverlayContext | null {
  const [overlay, setOverlay] = useState<SalesTargetSetOverlayContext | null>(
    () => getSalesTargetSetOverlayContext()
  );

  useEffect(() => subscribeSalesTargetSetOverlay(setOverlay), []);

  return overlay;
}
